<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_application_cancle" transform="translate(1580 2999)">
      <path
        id="패스_3897"
        data-name="패스 3897"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(-1580 -2999)"
      />
      <g id="그룹_8348" data-name="그룹 8348">
        <rect
          id="사각형_5792"
          data-name="사각형 5792"
          fill="#d5d8dc"
          width="18"
          height="18"
          rx="2"
          transform="translate(-1577 -2994)"
        />
        <path
          id="빼기_1"
          data-name="빼기 1"
          fill="#21bf54"
          d="M14,6H-4V4A2,2,0,0,1-2,2H2.171A3,3,0,0,1,7.829,2H12a2,2,0,0,1,2,2V6ZM5,2A1,1,0,1,0,6,3,1,1,0,0,0,5,2Z"
          transform="translate(-1573 -2998)"
        />
        <g
          id="그룹_9027"
          data-name="그룹 9027"
          transform="translate(1488.152 -1819.461) rotate(-45)"
        >
          <path
            id="패스_4055"
            data-name="패스 4055"
            fill="#363c43"
            d="M14.66,8H9v5.66h2V11.42l4.364,4.364,1.41-1.41L12.41,10h2.24V8Z"
            transform="translate(-1349.77 -2996)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
